export const DARK = 'dark';
export const WHITE = 'white';
export const ADMIN = 'admin';
export const THEME_TYPES = ['default-light', 'default-dark'];
